<template>
    <div>
        <div class="content-nav-wrapper">
            <div class="title-wrapper">
                <span class="title">{{ $t('comb.myVoiceTag') }}</span>
            </div>
            <span class="sub-title">选择您擅长的作品类型并根据试音文稿上传试音小样作为您的声音标签。通过审核后，我们将自动向您推荐该类型的演播邀约。优秀的声音标签将增大我们向您推荐的几率。<router-link
                    :to="{name: 'fastMissionIntro'}" style="color: #fc5832;text-decoration: underline;">了解更多</router-link></span>
            <span class="sub-title" style="margin-top: 0;">您最多可以上传3个声音标签</span>

        </div>
        <div class="tag-list-wrapper">
            <div class="tag-item" v-for="(tag,index) in tags" v-if="tag.auditStatus === 9">
                <span>{{ tag.categoryLabel }}</span>
                <a @click="deleteTag(tag.tagId, index)">删除标签</a>
            </div>
            <div class="tag-item-auditing" v-for="tag in tags" v-if="tag.auditStatus !== 9">
                <div class="tag-status">
                    <span>审核中</span>
                </div>
                <div class="title-wrapper">
                    <span class="title">{{ tag.categoryLabel }}</span>
                    <div class="attachment-wrapper">
                        <i class="icon icon-18 icon-upload mr10"></i>
                        <a :href="tag.audioUrl" download="voice">{{ tag.audioName }}</a>
                    </div>
                </div>
            </div>
            <div v-show="isShowNewTag" class="new-tag">
                <div class="left">
                    <span class="title">请选择一个你擅长的类型</span>
                    <el-cascader
                            size="small"
                            :props="props"
                            expand-trigger="hover"
                            :show-all-levels="false"
                            :options="options"
                            v-model="tagId"
                            style="width: 200px;"
                            placeholder="选择擅长分类"
                            @change="changeCascader"
                    ></el-cascader>
                    <span class="sub-title">请上传一个你的试读声音，我们将会审核</span>
                    <div class="download-content" :class="{'disabled': contentUrl === ''}">
                        <i class="icon icon-18 icon-check-audio mr10"></i>
                        <a href="javascript:;" @click="showAuditionContent(contentUrl)">查看试读选段({{ tagName }})</a>
                    </div>
                    <div class="upload-audio">
                        <i class="icon icon-18 icon-upload"></i>
                        <el-upload
                                :before-upload="beforeUpload"
                                :on-progress="uploadProgress"
                                class="upload-demo" :on-success="uploadSuccess"
                                action="/dtres/audio/upload" :show-file-list="false"
                                :file-list="fileList">
                            <el-button size="small" type="text">上传试读作品</el-button>
                        </el-upload>
                        <span>{{ audioName }}</span>
                    </div>
                </div>
                <div class="right">
                    <button @click="saveTag" class="submit-button" >提交</button>
                </div>
                <div class="cover" v-show="isNewTagLoading">
                    <el-progress type="circle" :percentage="progress"></el-progress>
                </div>
            </div>
            <button class="new-tag-btn" @click="showNewTag">添加标签</button>
        </div>
        <el-dialog title="提示" v-model="isShowHelp" size="tiny">
            <span style="display: block;text-align: center;">主播等级达到v4及以上才能参加海选，查看<a style="color:#fc5832;" :href="`${$store.state.A_PC_HOST}/c/anchor/help/center/anchorLevelTips`">如何提升</a>自己的主播等级。</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="isShowHelp = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog v-model="isShowAuditionContent" :close-on-click-modal="false" top="30%">
            <p style="white-space: pre-line; word-break: break-word; word-wrap: break-word;">{{ auditionContent }}</p>
        </el-dialog>
    </div>
</template>
<script>
    import axios from 'axios';
    import XiFooter from '../../components/Footer.vue';
    import XiTop from '../../components/Top.vue';
    import each from 'lodash/each';
    import findIndex from 'lodash/findIndex';
    export default {
        components: {
          axios,
          XiFooter,
          XiTop
        },
        data() {
            return {
                progress: 0,
                isNewTagLoading: false,
                isShowNewTag: false,
                isShowHelp: false,      // 是否显示主播等级低于4级的帮助
                audioName: '',          // 试读音频名字
                fileList: [],
                contentUrl: '',         // 试读选段URL
                tagName: '',
                options: [],
                tags: [],
                tagId: [1, 6],
                auditionContent: '',
                isShowAuditionContent: false,
                props: {
                  label: 'name',
                  value: 'categoryId',
                  children: 'children'
                }
            }
        },
        methods: {
          deleteTag(id, index) {
            this.$confirm('确定要删除声音当前标签？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
            }).then(() => {
              axios.post(`/api/anchor/tag/delete/${id}`).then(res => {
                if(res.data.code === 200) {
                  this.tags.splice(index, 1);
                  this.$notify({
                    type: 'info',
                    message: '标签删除成功',
                    duration: 2000
                  })
                }
              });
            });
          },
          beforeUpload () {
            this.isNewTagLoading = true;
            this.$notify({
              type: 'info',
              message: '正在上传音频',
              duration: 2000
            })
          },
          uploadProgress (event, file, fileList) {
            this.progress = parseInt(event.percent);
          },
          uploadSuccess (response, file, fileList) {
            this.audioName = file.name;
            this.audioId = response.data[0].uploadTrack.id;
            this.audioTranslation(0);
            this.progress = 0;
            this.$notify({
              type: 'info',
              message: '音频转码中，请稍后',
              duration: 2000
            })
          },
          audioTranslation (progress) {
            const that = this;
            if(progress >= 100) {
              this.isNewTagLoading = false;
            } else {
              this.progress = parseInt(progress);
              setTimeout(function() {
                axios.get(`/dtres/zhuanma/${that.audioId}/jindu/${Date.parse(new Date())}`).then(res => {
                  that.audioTranslation(res.data.value)
                });
              }, 500)
            }
          },
          getTagList() {
            axios.get('/api/anchor/tag/list').then(res => {
              if(res.data.code === 200) {
                this.tags = res.data.data;
              }
            });
          },
          getTagCategoryList () {
            axios.get('/api/anchor/tag/categories').then(res => {
              this.options = res.data.data;
            });
          },
          saveTag () {
            const that = this;
            const data = {
              audioId: this.audioId,
              audioName: this.audioName,
              categoryId: that.tagId[that.tagId.length - 1]
            }
            if (!data.audioId) {
              this.$notify({
                type: 'warning',
                message: '请先上传试音音频',
                duration: 0
              });
              return;
            }
            axios.post('/api/anchor/tag/save', data).then(res => {
              if(res.data.code === 200) {
                location.reload();
              } else {
                that.$notify({
                  type: 'warning',
                  message: res.data.message,
                  duration: 0
                })
                this.isNewTagLoading = false;
              }
            });
          },
          showNewTag () {
            if(this.tags.length < 3) {
              // if(this.$store.state.user.anchor.level < 4) {
              //   this.isShowHelp = true;
              // } else {
              //   this.isShowNewTag = true;
              // }
              this.isShowNewTag = true;
            } else {
              this.$notify({
                type: 'warning',
                message: '个人声音标签的数量最多三个',
              })
            }
          },
          getSampleContext () {
            const id = this.tagId[this.tagId.length-1];
            axios.get(`/api/sample/${id}`).then(res => {
              this.contentUrl = this.$store.state.UPLOAD_IMG_HOST + res.data.data.sampleFile;
              this.tagName = res.data.data.sampleName;
            });
          },
          changeCascader (tag) {
            this.getSampleContext();
          },
          showAuditionContent (url) {
            axios.get(url, {headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}}).then(res => {
              if(res.status === 200) {
                this.auditionContent = res.data;
              } else {
                this.$notify({
                  type: 'warning',
                  message: '没有找到试音文件，请联系管理员',
                  duration: 0
                });
              }
            })
            this.isShowAuditionContent = true;
          }
        },
        computed: {

        },
        beforeMount() {
          this.getTagList();
          this.getTagCategoryList();
          this.getSampleContext();
        }
    }

</script>
<style lang="sass" scoped>
    @import "../../../sass/anchor/my-voice-tag.scss";
    @import "../../../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// MyVoiceTag.vue?d59e0d68